import { Map as ImmutableMap, List, OrderedMap } from 'immutable';
import StateConstants from '../constants/StateConstants';
import CategoryRecord from '../records/edit/CategoryRecord';
const NEW_CATEGORY_RECORD = new CategoryRecord();
function countPublishedArticles(articles) {
  return articles.filter(article => article.values.hs_state === StateConstants.PUBLISHED).size;
}
export function getCountOfPublishedArticles(articles, subcategories = OrderedMap()) {
  return subcategories.reduce((count, subcategory) => count + countPublishedArticles(subcategory.articles), countPublishedArticles(articles));
}
export function getAllArticles(category = NEW_CATEGORY_RECORD) {
  return category.subcategories.reduce((articles, subcategory) => /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  articles.concat(subcategory.articles), category.articles);
}
export const flattenMultiLangCategories = (categories, parentName = null) => {
  return categories.reduce((acc, category) => {
    if (category.has('subcategories')) {
      acc = acc.concat(flattenMultiLangCategories(category.get('subcategories'), category.get('name')));
    }
    const categoryAndSubcategory = parentName ? List([parentName, category.get('name')]) : List([category.get('name')]);
    return acc.set(category.get('knowledgeCategoryId'), categoryAndSubcategory);
    // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  }, new ImmutableMap());
};
export const findMlangSelectedCategory = (categories, selectedCategoryId) => {
  const selectedCategory = categories.find(category => category.id === selectedCategoryId);
  if (!selectedCategory) {
    return categories.find(category => !!category.nameTranslations.find(nameTranslation => nameTranslation.id === selectedCategoryId));
  }
  return selectedCategory;
};
export function translate({
  category,
  requestedLanguage,
  primaryLanguage,
  isSubcategory = false
}) {
  var _category$translation, _category$translation2;
  if (!requestedLanguage || !primaryLanguage || !(!!((_category$translation = category.translations) !== null && _category$translation !== void 0 && _category$translation.size) ||
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly immutable list.
  !!((_category$translation2 = category.translations) !== null && _category$translation2 !== void 0 && _category$translation2.length))) {
    return category;
  }
  let {
    subcategories
  } = category;
  const {
    translations
  } = category;
  const requestedTranslation = translations.find(translation => translation.language === requestedLanguage);
  const primaryTranslation = translations.find(translation => translation.language === primaryLanguage);
  const hasRequestedTranslation = !!requestedTranslation;
  const hasAnyTranslation = !!primaryTranslation;
  const fallbackName = hasAnyTranslation ? primaryTranslation.name : '';
  const fallbackDescription = hasAnyTranslation ? primaryTranslation.description : '';
  const hasDescription = !isSubcategory && !!fallbackDescription;
  const hasTranslatedName = hasRequestedTranslation && !!requestedTranslation.name;
  const hasTranslatedDescription = hasRequestedTranslation && !!requestedTranslation.description;
  let isFullyTranslated = hasTranslatedName;
  if (hasDescription) {
    isFullyTranslated = hasTranslatedName && hasTranslatedDescription;
  }
  const name = hasTranslatedName ? requestedTranslation.name : fallbackName;
  const description = hasDescription ? hasTranslatedDescription ? requestedTranslation.description : fallbackDescription : undefined;
  if (!isSubcategory) {
    subcategories = subcategories.map(subcategory => translate({
      category: subcategory,
      primaryLanguage,
      requestedLanguage,
      isSubcategory: true
    }));
  }
  return category.merge({
    language: isFullyTranslated ? requestedLanguage : primaryLanguage,
    name,
    description,
    isFullyTranslated,
    subcategories
  });
}